
import Vue from 'vue'
import { IArticle } from '../store/state'

// Interfaces for component typechecking!
interface PuffProps {
	article: IArticle
}

export default Vue.extend<{}, {}, {}, PuffProps>({
	name: 'Puff',
	props: {
		article: {
			type: Object as () => IArticle,
			required: true
		}
	},
	computed: {
		
	},
	components: {
		
	}
})
